import React from 'react';

import { Box, Typography } from '@mui/material';
import Modal from 'components/ModalV2';
import Button from 'components/V2/Button';
import PropTypes from 'prop-types';
import { DISCARD_DIALOG_COPY } from 'views/V2/Integration/constants';

import styles from './discardChangesDialog.module.css';

function DiscardChangesDialog({ open, onKeepEditing, onDiscard }) {
    return (
        <Modal
            open={open}
            onClose={onKeepEditing}
            className={styles.container}
            disableBackdropClick
        >
            <Typography className={styles.title}>{DISCARD_DIALOG_COPY.TITLE}</Typography>
            <Typography className={styles.description}>
                {DISCARD_DIALOG_COPY.DESCRIPTION}
            </Typography>
            <Box className={styles.actions}>
                <Button intent="secondary" onClick={onKeepEditing}>
                    {DISCARD_DIALOG_COPY.SECONDARY_BTN}
                </Button>
                <Button intent="primary" onClick={onDiscard}>
                    {DISCARD_DIALOG_COPY.PRIMARY_BTN}
                </Button>
            </Box>
        </Modal>
    );
}

DiscardChangesDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onKeepEditing: PropTypes.func.isRequired,
    onDiscard: PropTypes.func.isRequired,
};

export default DiscardChangesDialog;
